import {TableCell, TableRow, Chip, Box, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import BankNoteIcon from '$assets/svgs/bank-note.svg?react';
import CreditCardIcon from '$assets/svgs/credit-card-x.svg?react';
import BankIcon from '$assets/svgs/bank.svg?react';
import {PaymentMethodType} from '../constant';
import {
  getPaymentStatusDisplay,
  getPaymentStatusType,
  formatCurrency,
  PaymentStatusInput,
} from '../../../utils';
import {PaymentInfo} from '../types';
import {ICON_DIMENSIONS} from './constants';
import './styles.scss';
import StripeIcon from '$assets/svgs/Stripe.svg?react';
import PayPalIcon from '$assets/svgs/paypal-icon.svg?react';
import LinkIcon from '$assets/svgs/Link.svg?react';

interface PaymentListRowProps {
  payment: PaymentInfo;
}

const PaymentStatusChip: React.FC<{status: PaymentStatusInput}> = ({
  status,
}) => {
  const statusType = getPaymentStatusType(status);
  return (
    <Chip
      label={getPaymentStatusDisplay(status)}
      className={`payment-status-chip payment-status-chip--${statusType}`}
      data-testid={`payment-status-${statusType}`}
    />
  );
};

const PaymentMethodDisplay: React.FC<{type: string}> = ({type}) => {
  const methodType = type as PaymentMethodType;
  switch (methodType) {
    case PaymentMethodType.Stripe:
      return (
        <StripeIcon
          width={ICON_DIMENSIONS.STRIPE.width}
          height={ICON_DIMENSIONS.STRIPE.height}
        />
      );
    case PaymentMethodType.Card:
      return (
        <Box className="payment-card-container">
          <CreditCardIcon
            width={ICON_DIMENSIONS.BANK_NOTE.width}
            height={ICON_DIMENSIONS.BANK_NOTE.height}
          />
          <Typography>Card</Typography>
        </Box>
      );
    case PaymentMethodType.Cash:
      return (
        <Box className="payment-card-container">
          <BankNoteIcon
            width={ICON_DIMENSIONS.BANK_NOTE.width}
            height={ICON_DIMENSIONS.BANK_NOTE.height}
          />
          <Typography>Cash</Typography>
        </Box>
      );
    case PaymentMethodType.Cheque:
      return (
        <Box className="payment-card-container">
          <BankIcon
            width={ICON_DIMENSIONS.BANK_NOTE.width}
            height={ICON_DIMENSIONS.BANK_NOTE.height}
            className="cheque-icon"
          />
          <Typography>Cheque</Typography>
        </Box>
      );
    case PaymentMethodType.PayPal:
      return (
        <Box className="payment-card-container">
          <PayPalIcon
            width={ICON_DIMENSIONS.BANK_NOTE.width}
            height={ICON_DIMENSIONS.BANK_NOTE.height}
          />
          <Typography>PayPal</Typography>
        </Box>
      );
    case PaymentMethodType.PaymentLink:
      return (
        <Box className="payment-card-container">
          <LinkIcon
            width={ICON_DIMENSIONS.BANK_NOTE.width}
            height={ICON_DIMENSIONS.BANK_NOTE.height}
          />
          <Typography>Payment link</Typography>
        </Box>
      );

    default:
      return <Typography>{type || '-'}</Typography>;
  }
};

function PaymentListRow({payment}: PaymentListRowProps) {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/staff/finance/payments/${payment.id}`);
  };

  return (
    <TableRow
      className="payment-list-row"
      onClick={handleRowClick}
      sx={{cursor: 'pointer'}}
    >
      <TableCell className="payment-list-cell">{payment.patientName}</TableCell>
      <TableCell className="payment-list-cell">
        {payment.invoiceNumber}
      </TableCell>
      <TableCell className="payment-list-cell">
        <PaymentStatusChip status={payment.status} />
      </TableCell>
      <TableCell className="payment-list-cell">
        {formatCurrency(payment.amount)}
      </TableCell>
      <TableCell className="payment-list-cell">
        <PaymentMethodDisplay type={payment.paymentMethodType} />
      </TableCell>
      <TableCell className="payment-list-cell">
        <Typography className="payment-billing-date">
          {payment.billingDate}
        </Typography>
      </TableCell>
    </TableRow>
  );
}

export default PaymentListRow;
